/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCourseFeedCourses } from '../services/operations/courseApi';
import Loading from './Loading';
import CourseCard from '../components/core/categoryPage/CourseCard';
import ConfirmationModal from '../components/common/ConfirmationModal';
import Footer from '../components/common/Footer';

const CoursesFeed = () => {
  const [courseFeed, setCourseFeed] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCourseFeedCourses(setCourseFeed, setConfirmationModal, setLoading));
  }, [dispatch]);
  if (loading) {
    return (
      <div className='w-screen h-screen'>
        <Loading />
      </div>
    );
  }

  return (
    <div>
      <div className='mt-14 w-11/12 max-w-maxContent overflow-hidden mx-auto py-10'>
        <div className='flex items-center justify-evenly flex-wrap gap-y-10 my-5'>
          {courseFeed?.length ? (
            courseFeed.map(course => (
              <div key={course?._id} className='w-[25rem] overflow-hidden'>
                <CourseCard course={course} cardHeight='16rem' />
              </div>
            ))
          ) : (
            <div
              className='text-richblack-5 text-3xl flex items-center justify-center h-[50vh]'
            >
              No Data Found For The Feed Reload or Contact Us.
            </div>
          )}
        </div>
      </div>
      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
      <Footer />
    </div>
  );
};

export default CoursesFeed;